import React, { useState } from "react";
import { Collapse, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import useScreen from "../hooks/useScreen";
import useScroll from "../hooks/useScroll";
import {
	AngleDown,
	BrightnessIcon,
	ClearIcon,
	Hamburger,
	SearchIcon,
} from "./Icon";
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';

const Header = () => {
	const scroll = useScroll();
	const [lang, setLang] = useState("Eng");
	const [searchOpen, setSearchOpen] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	const screen = useScreen();
	const { connection } = useConnection();
	const { publicKey, sendTransaction } = useWallet();

	return (
		<header className={`header-section ${scroll > 0 ? "active" : ""}`}>
			<div className="container">
				<div className="header-wrapper">
					<Link to="/" className="logo">
						<img src="/img/logo.png" alt="" />
					</Link>
					<div className="d-flex gap-2 gap-sm-4 flex-wrap align-items-center">
						{screen >= 992 && (
							<button
								type="button"
								className="no-gutter bg-transparent"
								onClick={() => setSearchOpen(!searchOpen)}
							>
								<SearchIcon />
							</button>
						)}
						<div className={`menu-wrapper ${menuOpen ? "active" : ""}`}>
							<button
								type="button"
								className="no-gutter bg-transparent  d-lg-none close-btn"
								onClick={() => setMenuOpen(false)}
							>
								<ClearIcon />
							</button>
							{screen < 992 && (
								<div className="mb-5">
									<SearchForm />
									<div className="mt-4">
										<HeaderButtons />
									</div>
								</div>
							)}
							<ul className="menu">
								{menu?.map((item) => (
									<MenuItem key={item.id} item={item} />
								))}
							</ul>
						</div>
					</div>
					<div className="d-flex align-items-center gap-3">
						{screen < 992 && (
							<button
								type="button"
								className="no-gutter bg-transparent"
								onClick={() => setMenuOpen(!menuOpen)}
							>
								<Hamburger />
							</button>
						)}
						<button type="button" className="no-gutter bg-transparent">
							<BrightnessIcon />
						</button>
						{/* <Dropdown className="lang-dropdown">
							<Dropdown.Toggle>
								<img src="/img/us.png" alt="" />
								<span className="icon-menu">{lang}</span>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{language?.map((item) => (
									<Dropdown.Item
										key={item.id}
										onClick={() => setLang(item?.name)}
									>
										<img src={item.img} alt="" />
										<span className="icon-menu">{item.name}</span>
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</Dropdown> */}
					</div>
					{screen >= 992 && <HeaderButtons />}
				</div>
				{screen >= 992 && (
					<Collapse in={searchOpen}>
						<div>
							<SearchForm />
						</div>
					</Collapse>
				)}
			</div>
		</header>
	);
};
const SearchForm = () => {
	const [value, setValue] = useState("");
	const handleSubmit = (e) => {
		e.preventDefault();
	};
	return (
		<>
			<div className="pt-3">
				<div className="search-form">
					<form onSubmit={handleSubmit}>
						<input
							type="text"
							placeholder="Search ..."
							className="form-control"
							value={value}
							onChange={(e) => setValue(e.target.value)}
						/>
					</form>
				</div>
			</div>
		</>
	);
};
const HeaderButtons = () => {
	return (
		<>
			<div className="header-buttons">
				{/* <Link to="#" className="login-btn">
					<span>Login</span>
				</Link> */}
				{/* <Link to="#" className="login-btn">
					<span>Connect</span>
				</Link> */}


				<div >
                    <WalletMultiButton className="login-btn"/>
                </div>

			</div>
		</>
	);
};
const MenuItem = ({ item }) => {
	// check mobile device
	const [collapse, setCollapse] = useState(false);
	const screen = useScreen();
	return (
		<li key={item.id}>
			<Link
				to={item?.link ? item?.link : "#"}
				onClick={() => setCollapse(!collapse)}
			>
				{item.name} {item?.submenu?.length > 0 ? <AngleDown /> : ""}{" "}
			</Link>
			{screen < 992 ? (
				<Collapse in={collapse}>
					<div>
						<ul className="submenu">
							{item?.submenu?.map((sub) => (
								<li key={sub.id}>
									<Link to={sub.link}>{sub.name} </Link>
								</li>
							))}
						</ul>
					</div>
				</Collapse>
			) : (
				item?.submenu?.length > 0 && (
					<ul className="submenu">
						{item?.submenu?.map((sub) => (
							<li key={sub.id}>
								<Link to={sub.link}>{sub.name} </Link>
							</li>
						))}
					</ul>
				)
			)}
		</li>
	);
};
const language = [
	{
		id: 1,
		name: "Eng",
		img: "/img/us.png",
	},
	{
		id: 2,
		name: "Fra",
		img: "/img/us.png",
	},
];
const menu = [
	{
		id: 1,
		name: "Tools",
		link: "",
		submenu: [
			{
				id: 1,
				name: "SOL Sender",
				link: "https://tools.solrocket.io/sol-sender",
			},
			{
				id: 2,
				name: "SPL sender",
				link: "https://tools.solrocket.io/spl-sender",
			},
			{
				id: 3,
				name: "Create SPL Token",
				link: "https://tools.solrocket.io/spl-creator",
			},
			{
				id: 4,
				name: "Airdrop Devnet SOL",
				link: "https://tools.solrocket.io/sol-faucet",
			},
		],
	},
	{
		id: 2,
		name: "Locker",
		link: "",
		submenu: [
			{
				id: 1,
				name: "LP Locker",
				link: "/lock-page",
			},
			{
				id: 2,
				name: "Token Locker",
				link: "/lock-page",
			},

		],
	},
	{
		id: 3,
		name: "Forms",
		link: "",
		submenu: [
			{
				id: 1,
				name: "Contact US",
				link: "https://solrocket.fillout.com/t/qe8V1KBPLZus",
			},
			{
				id: 2,
				name: "Partnership",
				link: "https://solrocket.fillout.com/t/5bvw4LNeaXus",
			},
			{
				id: 3,
				name: "Submit your Project",
				link: "https://solrocket.fillout.com/t/geZ9pQHAPvus?solrocket=xxxxx",
			},
		],
	},
];
export default Header;
